const businessCustomersBtn = document.getElementById('businessCustomerbtn');
const privateCustomersBtn = document.getElementById('privateCustomerbtn');

const contactForm = document.getElementById('ContactForm');
const customerTypeDropdown = contactForm.querySelector('#ContactForm-customer_type');
const companyField = contactForm.querySelector('#ContactForm-company');
const productTypeField = contactForm.querySelector('#ContactForm-product_type');

customerTypeDropdown.addEventListener('change', (event) => {
   const value = event.target.value;
   if( value === 'Cliente Business' )
   {
      companyField.disabled = false;
      companyField.closest('.field').style.display = 'block';
      productTypeField.disabled = false;
      productTypeField.closest('.field').style.display = 'block';
   }else if( value === 'Cliente Privato' )
   {
      companyField.disabled = true;
      companyField.closest('.field').style.display = 'none';
      productTypeField.disabled = true;
      productTypeField.closest('.field').style.display = 'none';
   }else{
      return;
   }
});

businessCustomersBtn.addEventListener('click', () => {
   customerTypeDropdown.value = 'Cliente Business';
   customerTypeDropdown.dispatchEvent(new Event('change'));
});

privateCustomersBtn.addEventListener('click', () => {
   customerTypeDropdown.value = 'Cliente Privato';
   customerTypeDropdown.dispatchEvent(new Event('change'));
});